$(document).ready(function () {
    site.base.contactMessage();
    site.base.b2bContactMessage();
    site.base.redCircleLink();
    site.base.changeLocale();
    site.base.initCookies();
    site.base.pauseCycleCarousel();

    site.product.tileTabs();
});